import {Body, get, post, put, remove} from "../Api/Provider";
import {TOUR_SERVICE_PROVIDER_URL} from "./constants";

export async function getTourServiceProviders() {
    let TourServiceProvider: { [key: string | number]: any }[];
    TourServiceProvider = await get(TOUR_SERVICE_PROVIDER_URL).then(async res => {
        return await res?.json();
    });
    return TourServiceProvider;
}

export async function getTourServiceProvider(name: string) {
    return await get(`${TOUR_SERVICE_PROVIDER_URL}/name/${name}`).then(async res => {
        return await res?.json()
    })
}

export async function onAddTourServiceProvider(name: string, address: string, contactName: string, phone: string): Promise<boolean> {
    const body = {
        name: name,
        address: address,
        contactName: contactName,
        phone: phone,
    };

    try {
        const res = await post(TOUR_SERVICE_PROVIDER_URL, body);
        if (!res) {
            return false;
        }
        const data = await res.json();
        console.log("data.errors: ", data.errors);
        return !data.errors;
    } catch (e) {
        return false;
    }
}

export async function onPutTourServiceProvider(id: number | undefined, name: string, address: string, contactName: string, phone: string): Promise<boolean> {
    if (id === undefined)
        return onAddTourServiceProvider(name, address, contactName, phone);

    let body: Body = {
        id: id,
        name: name,
        address: address,
        contactName: contactName,
        phone: phone,
    }

    try {
        const res = await put(TOUR_SERVICE_PROVIDER_URL, body);
        if (!res) {
            return false;
        }
        return res.status === 204;

    } catch (e) {
        return false;
    }
}

export async function onDeleteTourServiceProvider(name: string): Promise<boolean> {

    try {
        const res = await remove(`${TOUR_SERVICE_PROVIDER_URL}/name/${name}`);
        if (!res) {
            return false;
        }
        return res.status === 200 || res.status === 204;
    } catch (e) {
        return false;
    }

}